module.exports = __webpack_public_path__ + "static/media/02-Banque-Mondiale.83ccba37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_banque-mondiale/02-Banque-Mondiale.jpg
// module id = 1181
// module chunks = 37